import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { DesktopMenu, MenuItems, MobileMenu } from "src/widgets/menu";
import { currentUserState } from "@app/store/authSlice";
import { showEnterForm } from "@app/store/layoutSlice";
import { RouterConfig } from "@shared/lib/routerConfig";
import { PlusIcon } from "@shared/ui/Icon/ui/Common/PlusIcon";
import { EnterIcon } from "@shared/ui/Icon/ui/Navigation/EnterIcon";
import { FavoriteIcon } from "@shared/ui/Icon/ui/Navigation/FavoriteIcon";
import { HomeIcon } from "@shared/ui/Icon/ui/Navigation/HomeIcon";
import { CompanyIcon } from "@shared/ui/Icon/ui/Profile/CompanyIcon";
import { ProfileIcon } from "@shared/ui/Icon/ui/Profile/ProfileIcon";
import { Logo } from "@shared/ui/logo";
import { UserMenu } from "./user-menu";
import classes from "./header.module.scss";

const Header = () => {
    const router = useRouter();
    const [isUserMenuOpened, setIsUserMenuOpened] = useState(false);
    const currentUser = useSelector(currentUserState);
    const dispatch = useDispatch();

    let activeItem = MenuItems.find((el) => {
        return router.pathname.startsWith(el.link);
    });

    const toggleUserMenu = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsUserMenuOpened((prev) => !prev);
    };

    activeItem = activeItem
        ? activeItem
        : {
              title: "Главная",
              icon: HomeIcon,
              link: RouterConfig.MAIN
          };

    return (
        <div className={classes.header}>
            <div className={classes.header__container}>
                <div className={classes.header__left}>
                    <Logo className={classes.header__logo} isMono={true} />
                    <DesktopMenu
                        activeItem={activeItem}
                        className={classes["header__menu-desktop"]}
                    />
                    <MobileMenu
                        activeItem={activeItem}
                        className={classes["header__menu-mobile"]}
                    />
                </div>
                <div className={classes.header__right}>
                    {!currentUser ? (
                        <button
                            className={classes.header__button}
                            onClick={() => dispatch(showEnterForm())}
                            aria-label={"Войти"}
                        >
                            <EnterIcon />
                            <span className={classes["header__button--text"]}>Войти</span>
                        </button>
                    ) : (
                        <div className={classes.header__user}>
                            <button className={classes.header__button} onClick={toggleUserMenu}>
                                {currentUser.isCompany ? <CompanyIcon /> : <ProfileIcon />}
                                <span className={classes["header__button--text"]}>
                                    {currentUser.isCompany
                                        ? currentUser.companyName
                                        : currentUser.name}
                                </span>
                            </button>
                            {isUserMenuOpened && (
                                <UserMenu
                                    isCompany={currentUser.isCompany}
                                    close={() => setIsUserMenuOpened(false)}
                                />
                            )}
                        </div>
                    )}
                    <div className={classes.header__divider} />
                    <a
                        className={classes.header__link}
                        aria-label="Избранное"
                        href={RouterConfig.FAVORITES}
                    >
                        <FavoriteIcon hasNotifications={false} />
                    </a>
                    <button
                        className={classes.header__post}
                        aria-label="Создать объявление"
                        onClick={() => {
                            router.push(RouterConfig.CREATE_OFFER);
                        }}
                    >
                        <PlusIcon />
                        <span className={classes["header__post--text"]}>Создать объявление</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Header;